var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 485.156,
    height: 343.159,
    viewBox: "0 0 485.156 343.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "code-group",
    transform: "translate(-1460.558 -347.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "code-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 83.907,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1561.677 369.155)",
    fill: "#89c275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 49.484,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1482.073 369.155)",
    fill: "#9d75b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1539.087 369.155)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1471.315 358.398)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1653.115 369.155)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1471.315 379.912)",
    fill: "#e3523b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 43.029,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1699.371 424.018)",
    fill: "#dbc655"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 57.014,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1767.142 401.427)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 38.726,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1561.677 401.427)",
    fill: "#89c275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 49.484,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1482.073 401.427)",
    fill: "#9d75b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1539.087 401.427)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1471.315 390.67)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1607.934 401.427)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1471.315 448.759)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 101.119,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1658.493 401.427)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1630.524 401.427)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 57.014,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1753.158 424.018)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 83.907,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1583.192 424.018)",
    fill: "#89c275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 49.484,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1503.588 424.018)",
    fill: "#9d75b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1560.601 424.018)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1492.83 413.26)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1674.629 424.018)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1492.83 434.775)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 101.119,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1817.702 424.018)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1925.275 424.018)",
    fill: "#f3f4fd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1471.315 459.517)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1471.315 481.032)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 57.014,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1630.524 470.274)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 38.726,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1561.677 470.274)",
    fill: "#89c275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 49.484,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1482.073 470.274)",
    fill: "#9d75b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1539.087 470.274)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1607.934 470.274)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 101.119,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1720.886 470.274)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1693.993 470.274)",
    fill: "#f3f4fd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-4",
    transform: "translate(1460.558 347.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 43.029,
    height: 4.303,
    rx: 2.151,
    transform: "translate(206.541 153.83)",
    fill: "#dbc655"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 57.014,
    height: 4.303,
    rx: 2.151,
    transform: "translate(178.572 164.587)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 43.029,
    height: 4.303,
    rx: 2.151,
    transform: "translate(133.391 153.83)",
    fill: "#89c275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 70.998,
    height: 4.303,
    rx: 2.151,
    transform: "translate(32.272 153.83)",
    fill: "#9d75b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(110.801 153.83)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(21.515 143.073)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(183.951 153.83)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(21.515 207.617)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 101.119,
    height: 4.303,
    rx: 2.151,
    transform: "translate(69.923 164.587)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(41.954 164.587)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 57.014,
    height: 4.303,
    rx: 2.151,
    transform: "translate(41.954 175.345)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 101.119,
    height: 4.303,
    rx: 2.151,
    transform: "translate(106.498 175.345)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(215.147 175.345)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 44.105,
    height: 4.303,
    rx: 2.151,
    transform: "translate(41.954 186.102)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 70.998,
    height: 4.303,
    rx: 2.151,
    transform: "translate(93.589 186.102)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(172.118 186.102)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 57.014,
    height: 4.303,
    rx: 2.151,
    transform: "translate(150.603 196.859)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 101.119,
    height: 4.303,
    rx: 2.151,
    transform: "translate(41.954 196.859)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(215.147 196.859)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 35.499,
    height: 4.303,
    rx: 2.151,
    transform: "translate(200.087 186.102)",
    fill: "#f3f4fd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1460.558 347.64)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(1460.558 686.497)",
    fill: "#e3523b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-5",
    transform: "translate(1460.558 347.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(10.757 219.45)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 26.893,
    height: 4.303,
    rx: 2.151,
    transform: "translate(10.757 262.479)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 57.014,
    height: 4.303,
    rx: 2.151,
    transform: "translate(193.632 240.965)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 38.726,
    height: 4.303,
    rx: 2.151,
    transform: "translate(101.119 230.207)",
    fill: "#89c275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 49.484,
    height: 4.303,
    rx: 2.151,
    transform: "translate(21.515 230.207)",
    fill: "#9d75b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(78.529 230.207)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(147.376 230.207)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 101.119,
    height: 4.303,
    rx: 2.151,
    transform: "translate(84.983 240.965)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 36.575,
    height: 4.303,
    rx: 2.151,
    transform: "translate(41.954 240.965)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 43.029,
    height: 4.303,
    rx: 2.151,
    transform: "translate(169.966 230.207)",
    fill: "#dbc655"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 38.726,
    height: 4.303,
    rx: 2.151,
    transform: "translate(83.907 251.722)",
    fill: "#89c275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 32.272,
    height: 4.303,
    rx: 2.151,
    transform: "translate(21.515 251.722)",
    fill: "#9d75b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(61.317 251.722)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(130.164 251.722)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 24.742,
    height: 4.303,
    rx: 2.151,
    transform: "translate(152.754 251.722)",
    fill: "#dbc655"
  })), /*#__PURE__*/React.createElement("g", {
    id: "code-6",
    transform: "translate(1460.558 347.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(21.515 273.237)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(21.515 292.827)",
    fill: "#e3523b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "code-line",
    transform: "translate(42.515 282.994)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 100.043,
    height: 4.303,
    rx: 2.151,
    transform: "translate(206.541)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 36.575,
    height: 4.303,
    rx: 2.151,
    transform: "translate(79.604)",
    fill: "#89c275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 49.484,
    height: 4.303,
    rx: 2.151,
    fill: "#9d75b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(57.014)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 15.06,
    height: 4.303,
    rx: 2.151,
    transform: "translate(123.709)",
    fill: "#4762db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 101.119,
    height: 4.303,
    rx: 2.151,
    transform: "translate(314.114)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 20.439,
    height: 4.303,
    rx: 2.151,
    transform: "translate(421.688)",
    fill: "#f3f4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 53.787,
    height: 4.303,
    rx: 2.151,
    transform: "translate(145.224)",
    fill: "#f3f4fd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeGroup);
export default __webpack_public_path__ + "static/media/code-group.23eedcfd8cc38b0570df4aae82a4127e.svg";
export { ForwardRef as ReactComponent };